import { Box, Button, Avatar } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import Seperator from "../Seperator";
import styles from "./Navbar.module.css";
import SidebarData from "./Sidebar";

const Navbar = () => {
  const location = useLocation();
  const [toggle, setToggle] = useState(true);
  const [title, setTitle] = useState("Dashboard");
 
  const hideChildData = () => setToggle((prev) => !prev);
  useEffect(() => {
    const path = location.pathname;
    const pathTitleMap = {
      "/dashboard": "Dashboard",
      "/settings": "Settings",
      "/settings/services": "Services",
      "/worklist": "Work List",
      "/worklist/myworklist": "My Work List",
      "/worklist/carepreneur": "Carepreneur",
      "/worklist/hospital": "Hospital",
      "/settings/languages": "Languages",
      "/settings/prefered-zone": "Location",
      "/settings/status": "Status",
      "/settings/googlemapkey": "Google Map Key",
      "/settings/availble-shifts": "Available-Shifts",
      "/settings/days-available": "Days-Available",
      "/settings/education-levels": "Education-Levels",
      "/settings/hospital-facilities": "Hospital Facility",
      "/settings/facility-service": "Facility Service",
      "/settings/states": "States",
      "/settings/districts": "Districts",
      "/settings/cities": "Cities",
      "/settings/co-ordinator": "Co-Ordinators",
       "/settings/managers": "Managers",
      "/settings/lead-source": "Lead-Source",
      "/settings/interaction-type": "Interaction-Type",
      "/settings/interaction-channel": "Interaction-Channel",
      "/settings/interaction-outcome": "Interaction-Outcome",
      "/settings/followupmode": "FollowUpMode",
      "/settings/resourcetype": "ResourceType",
      "/settings/assessment-type": "AssessmentType",
      "/settings/assessment-mode": "AssessmentMode",
      "/settings/risk-category": "RiskCategory",
      "/settings/resource-category": "ResourceCategory",
      "/settings/relations": "Relations",
      "/settings/tariffs": "Tariffs",
      "/marketing/blog-categories": "Blog Categories",
      "/marketing/blog-posts": "Blog Posts",
      "/marketing/contacts": "Contacts",
      "/marketing/seo-url": "Seo-Url",
     
    };

    setTitle(pathTitleMap[path] || "Dashboard");
  }, [location.pathname]);

  return (
    <div className={styles.dblayout}>
      <Box>
        <section className={styles.navbar}>
          <img
            src={require("../dashboard/images/Wihan Logo.png")}
            className={styles.logo}
            alt="logo"
            onClick={() => (window.location.href = "/")}
          />
          <Seperator direction="vertical" />
          <GiHamburgerMenu className={styles.hammenu} onClick={hideChildData} />
          <p
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginLeft: "20px",
            }}
          >
            {title}
          </p>

          <Avatar
            alt="user"
            src={require("../images/avatar.png")}
            style={{ marginLeft: "auto" }}
          />
          <Button
            variant="contained"
            style={{ marginLeft: "10px" }}
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("role");
              localStorage.removeItem("activeNav");
              localStorage.removeItem("activeChildPath");
              localStorage.removeItem("carepreneur_id");
              window.location.href = "/login";
            }}
          >
            Logout
          </Button>
        </section>
      </Box>
      <div className={styles.dbcontent}>
        <SidebarData toggle={toggle} />
        <div className={styles.outlet}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
